(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const gate = document.getElementById('AgeGate');
    const confirm = document.getElementById('AgeGateConfirm');
    if (!gate || !confirm) return;
    const storageKey = 'kissyouen-age-18-v1';
    let verified = false;
    let sourceCard = null;
    let scrollPosition = 0;
    try { verified = sessionStorage.getItem(storageKey) === 'yes'; } catch (error) {}
    const revealImages = () => {
      if (!verified) return;
      document.querySelectorAll('template[data-age-images]').forEach((template) => {
        const placeholder = template.previousElementSibling;
        template.replaceWith(template.content.cloneNode(true));
        if (placeholder && placeholder.hasAttribute('data-age-placeholder')) placeholder.remove();
      });
    };
    const focusMain = () => {
      const target = sourceCard && sourceCard.querySelector('a') || document.querySelector('main');
      if (target) {
        if (!target.hasAttribute('tabindex')) target.tabIndex = -1;
        target.focus({ preventScroll: true });
      }
    };
    if (verified) { gate.hidden = true; revealImages(); }
    else if (!gate.hidden) confirm.focus();
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-age-open]');
      if (!trigger) return;
      event.preventDefault();
      sourceCard = trigger.closest('.product');
      scrollPosition = window.scrollY;
      gate.hidden = false;
      confirm.focus();
      window.scrollTo(0, 0);
    });
    confirm.addEventListener('click', () => {
      verified = true;
      try { sessionStorage.setItem(storageKey, 'yes'); } catch (error) {}
      gate.hidden = true;
      revealImages();
      focusMain();
      if (sourceCard) window.scrollTo(0, scrollPosition);
    });
    new MutationObserver(revealImages).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', () => {
      try { verified = verified || sessionStorage.getItem(storageKey) === 'yes'; } catch (error) {}
      if (verified) { gate.hidden = true; revealImages(); }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
